import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Alert, { AlertVariant } from '../../components/Alert';
import Button from '../../components/Button';
import Container from '../../components/Container';
import Input from '../../components/Input';
import Typography from '../../components/Typography';

import ServiceRegistration from '../../services/RegisterService';

import { setStorageWithTtl, getStorage } from '../../helpers/Storage';
import {
  gtmAttributesActiveAlert,
  gtmAttributesProcessingShipping,
  gtmAttributesNotMyEmail,
  gtmAttributesResend,
  gtmAttributesUpdateResendEmailPage,
} from '../../utils/gtmVariables';
import useGTMEventsTracker from '../../hooks/useGTMEventsTracker';

const serviceRegistration = new ServiceRegistration();
const gtmEventsTracker = useGTMEventsTracker();

const ResendEmail = () => {
  const [show, setShow] = useState(false);
  const [variant, setVariant] = useState<AlertVariant | undefined>(undefined);
  const [message, setMessage] = useState(<></>);
  const [waitingIdwall, setWaitingIdwall] = useState(false);
  const [email] = useState(getStorage('sellerEmail') || '');
  const navigate = useNavigate();

  gtmEventsTracker(gtmAttributesUpdateResendEmailPage);

  const handleSubmit = async () => {
    setStorageWithTtl('waiting_request_processing', email, 1);
    setWaitingIdwall(true);
    try {
      const sellerId = JSON.parse(getStorage('seller')).id;
      serviceRegistration
        .resendEmail(sellerId)
        .then(() => {
          setVariant('success');
          setMessage(<>Email enviado.</>);
          setShow(true);
          gtmEventsTracker(gtmAttributesActiveAlert);
        })
        .catch(() => {
          setVariant('warning');
          setMessage(
            <>
              Estamos processando seu pedido de reenvio. Seu email poderá chegar em até 8 minutos.{' '}
              <strong>Se não chegar, tente novamente ou entre em contato com nosso suporte.</strong>
            </>
          );
          setShow(true);
          gtmEventsTracker(gtmAttributesProcessingShipping);
          gtmEventsTracker(gtmAttributesResend);
        });
    } catch (error) {}
  };

  const notMyEmail = () => {
    navigate('/update-email', { replace: true });
    gtmEventsTracker(gtmAttributesNotMyEmail);
  };

  useEffect(() => {
    getStorage('waiting_request_processing') ? setWaitingIdwall(true) : setWaitingIdwall(false);
  }, []);

  return (
    <div className="flex items-center justify-center max-[768px]:items-start">
      <Container className="w-full flex justify-center">
        <div className="bg-neutral-light/20 max-w-[712px] w-full rounded-lg px-28 py-16 mt-12 mb-28 flex flex-col gap-12 max-[768px]:bg-transparent max-[768px]:px-0 max-[768px]:mt-0 max-[768px]:pt-12 max-[768px]:mb-16 max-[768px]:gap-12">
          <div className="flex flex-col gap-6">
            <Typography as="h1" variant="title1" className="text-neutral-darkest">
              Não recebeu o nosso email?
            </Typography>
            <Typography as="p" variant="body2" className="text-neutral-darkest">
              Pode levar até 8 minutos pra ele chegar. Lembre-se de checar a caixa de spam e, se
              mesmo assim não receber, entre em contato com nosso suporte.
            </Typography>
          </div>
          <Input
            label="Email cadastrado"
            type="email"
            name="registered-email"
            className="w-full"
            disabled={true}
            value={email}
          />
          <div className="flex gap-4 md:[&>div]:basis-1/2 max-[768px]:flex-col max-[768px]:gap-6">
            <div className="hidden md:block">
              <Button
                variant="secondary"
                type="button"
                text="Este não é meu email"
                onClick={notMyEmail}
              />
            </div>
            <Button
              variant="primary"
              type="button"
              text="Reenviar email"
              onClick={handleSubmit}
              disabled={waitingIdwall}
            />
            <button
              type="button"
              onClick={notMyEmail}
              className="md:hidden text-center text-support2-medium hover:text-support2-dark font-bold text-sm leading-4"
            >
              Este não é meu email
            </button>
          </div>
        </div>
        <div className="absolute top-[3.688rem] right-[5.5rem] w-[23.625rem] max-[768px]:top-[4.688rem] max-[768px]:w-full max-[768px]:right-0 max-[768px]:px-5 max-[768px]:py-6">
          <Alert show={show} variant={variant} onClose={() => setShow(false)} dismissible>
            <Typography as="p" variant="body2">
              {message}
            </Typography>
          </Alert>
        </div>
      </Container>
    </div>
  );
};

export default ResendEmail;
